import * as React from 'react';
import { LayoutEnum } from '@app/common';
import { useRootStore } from '../../../providers/root-store-provider';
import { HeaderMobile } from './mobile/header-mobile';
import { HeaderVertical } from './vertical/header-vertical';
import { HeaderHorizontal } from './horizontal/header-horizontal';
import { Responsive } from '../../../components/app/responsive/responsive';
import { cn } from '../../../utils/tailwind';

export const Header: React.FC = () => {
    const rootStore = useRootStore();
    const { layout, showHeaderBar } = rootStore.themeStore;

    return (
        <div
            className={cn(
                'relative z-[901]',
                layout === LayoutEnum.Vertical && 'sticky top-0',
                layout === LayoutEnum.Horizontal && 'max-vl:sticky max-vl:top-0',
                showHeaderBar && 'sticky top-0 vl:top-bar',
            )}
        >
            <Responsive breakpoint="vl" type="max">
                <HeaderMobile />
            </Responsive>
            <Responsive breakpoint="vl">
                <>
                    {layout === LayoutEnum.Horizontal && <HeaderHorizontal />}
                    {layout === LayoutEnum.Vertical && <HeaderVertical />}
                </>
            </Responsive>
        </div>
    );
};
